module.exports = __webpack_public_path__ + "static/media/shopping-bag.4b4aeed6.svg";